import Drip from "../../apis/Drip";
import User from "../../apis/User.js";
import router from "../../router";

const state = {
  dripGroups: [],
  drips: [],
  drip: [
    {
      domain_id: "",
      group_id: "",
      drip_number: "",
      type: "welcome",
      title: "",
      body: "",
      icon: null,
      customization: {
        requireInteraction: false,
        image: "",
        ttl: "",
        button1: {
          title: "",
          url: "",
        },
        button2: {
          title: "",
          url: "",
        },
      },
      offset: null,
      sended: null,
      delivered: null,
      clicked: null,
      is_active: null,
      schedule: {
        domain_id: "",
        name: "welcomeScheduleName",
        type: "welcome",
        frequency: null,
        time: null,
        date_start: null,
        date_end: null,
        after_days: 0,
        after_hours: 0,
        after_mins: 0,
        from_when: "subscribed",
        last_disp_date: null,
        next_disp_date: null,
        timezone: "",
        days_of_week:
          "Monday Tuesday Wednesday Thursday Friday Saturday Sunday",
        is_active: null,
      },
    }],
  dripForCreating:
    [{
      "domain_id": "",
      "drip_number": "",
      "type": "welcome",
      "title": "",
      "body": "",
      "url": null,
      "icon": "",
      "customization": {
        "button1": {
          "title": "",
          "url": ""
        },
        "button2": {
          "title": "",
          "url": ""
        },
        "image": "",
        "requireInteraction": false,
      },
      "offset": null,
      "sended": null,
      "delivered": null,
      "clicked": null,
      "meta": {
        "test": 2223
      },
      "created_at": "",
      "updated_at": "",
      "schedule":
      {
        "domain_id": "",
        "group_id": "",
        "name": "",
        "type": "welcome",
        "frequency": null,
        "time": null,
        "date_start": null,
        "date_end": null,
        "after_days": "",
        "after_hours": "",
        "after_mins": "",
        "from_when": "subscribed",
        "last_disp_date": null,
        "next_disp_date": null,
        "created_at": "",
        "updated_at": "",
        "timezone": "UTC",
        "days_of_week": "Monday Tuesday Wednesday Thursday Friday Saturday Sunday",
        "is_active": 0,
      }

    }],
  dripGroupForCreating:
    [{
      "domain_id": "",
      "drip_number": 1,
      "type": "welcome",
      "title": "",
      "body": "",
      "url": null,
      "icon": "",
      "customization": {
        "button1": {
          "title": "",
          "url": ""
        },
        "button2": {
          "title": "",
          "url": ""
        },
        "image": "",
        "requireInteraction": false,
      },
      "offset": null,
      "sended": null,
      "delivered": null,
      "clicked": null,
      "meta": {
        "test": 2223
      },
      "created_at": "",
      "updated_at": "",
      "schedule":
      {
        "domain_id": "",
        "group_id": "",
        "name": "",
        "type": "welcome",
        "frequency": null,
        "time": null,
        "date_start": null,
        "date_end": null,
        "after_days": "",
        "after_hours": "",
        "after_mins": "",
        "from_when": "subscribed",
        "last_disp_date": null,
        "next_disp_date": null,
        "created_at": "",
        "updated_at": "",
        "timezone": "UTC",
        "days_of_week": "Monday Tuesday Wednesday Thursday Friday Saturday Sunday",
        "is_active": 0,
      }

    }],
  errorWelcomeDrip: "",
};

// To Handle Getters
const getters = {
  getDrips(state) {
    return state.drips;
  },
  getDripForCreating(state) {
    return state.dripForCreating;
  },
  getDripGroupForCreating(state) {
    return state.dripGroupForCreating;
  },
  selectedDrip: state => id => {
    if (id || id == 0) {
      return state.drips["data"] ? state.drips["data"].findIndex((el) => el.id == id) : state.drips.findIndex((el) => el.id == id)
    }
  },
};

const actions = {
  updateGroupSchedule({ commit }, { domainId, welcomeGroupId, obj }) {
    return new Promise((resolve, reject) => {
      Drip.updateGroupSchedule("welcome", domainId, welcomeGroupId, obj)
        .then((response) => {
          resolve(response);
          console.log("🚀 ~ .then ~ response:", response)
          //commit("UPDATE_GROUPS_SCHEDULE", response.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        })
    })
  },
  createOrUpdateWelcome({ commit }, { json, withReplaceUrlButtons }) {
    return new Promise((resolve, reject) => {
      Drip.createOrUpdate("welcome", json, withReplaceUrlButtons)
        .then((response) => {
          resolve(response);
          commit("CREATE_OR_UPDATE", response.data.data);
        })
        .catch((err) => {
          reject(err);
          if (err.response) {
            commit("DETECT_ERROR", err.response);
          }
        })
    })
  },
  getDripGroups(
    { commit },
    {
      params = `?group_by=group_id&with[schedules]=name,type,is_active,after_mins,oper_alg&order_by=id:desc&where[domain_id]=${router.history.current.params.id}&select=id,group_id,is_active,title,body,created_at`,
      //params = `?group_by=group_id&where[domain_id]=${router.history.current.params.id}&order_by=id:desc&select=group_id,is_active,title,body,created_at`,
      headers = {
        Accept: "application/json",
      } }
  ) {
    return new Promise((resolve, reject) => {
      Drip.get("welcome", params, headers)
        .then((response) => {
          resolve(response);

          // if (!response.data.data.length) {
          //   router.push({ name: "Page Not Found" });

          //   return false;
          // }

          commit("GET_DRIP_GROUPS", response.data.data);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            commit("GET_DRIP_GROUPS", []);
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  addDripGroup({ commit }, data) {
    return new Promise((resolve, reject) => {
      Drip.createOrUpdate("welcome", data.json)
        .then((response) => {
          resolve(response);
          commit("ADD_NEW_DRIP_GROUP", response["data"]["data"][0]);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  delDripGroup({ commit }, group_id) {
    return new Promise((resolve, reject) => {
      Drip.deleteGroup("welcome", group_id)
        .then((response) => {
          resolve(response);
          commit("DELETE_DRIP_GROUP", group_id);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },

  updateStatus({ commit }, ...args) {
    Drip.updateStatus("welcome", args[0][0], args[0][1], args[0][2])
      .then(() => {
        commit("UPDATE_STATUS", args);
      })
      .catch((error) => {
        if (error.response) {
          commit("DETECT_ERROR", error.response);
        }
      })
  },

  getDrips({ commit }, params) {
    return new Promise((resolve, reject) => {
      Drip.get("welcome", params)
        .then((response) => {
          resolve(response)

          // if (!response.data.data.length) {
          //   router.push({ name: "Page Not Found" });

          //   return false;
          // }

          commit("GET_DRIPS", response.data.data);
        })
        .catch((error) => {
          reject(error)
          if (error.response) {
            commit("GET_DRIPS", []);
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  addNewDrip({ commit }, args) {
    Drip.createOrUpdate("welcome", args[0])
      .then((response) => {
        commit("ADD_NEW_DRIP", response.data.data[0]);
      })
      .catch((error) => {
        alert(error)
        if (error.response) {
          commit("DETECT_ERROR", error.response);
        }
      })
  },
  updateAllWelcomeDrips({ commit }, array) {
    return new Promise((resolve, reject) => {
      Drip.createOrUpdate("welcome", array)
        .then((response) => {
          resolve(response);

          commit("UPDATE_ALL_DRIPS", response.data.data);
        })
        .catch((error) => {
          reject(error);

          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  updateDrip({ commit }, json) {
    Drip.createOrUpdate("welcome", json)
      .then((response) => {
        commit("UPDATE_DRIP", response["data"]["data"]);
      })
      .catch((error) => {
        if (error.response) {
          commit("DETECT_ERROR", error.response);
        }
      })
  },
  // Request To Delete Drip
  deleteDrip({ commit }, data) {
    return new Promise((resolve, reject) => {
      Drip.delete("welcome", data.group_id, data.id)
        .then((response) => {
          resolve(response);
          commit("DELETE_DRIP", data.id);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  deleteDripArray({ commit }, { domainId, ids }) {
    let formData = new FormData();

    formData.append("domain_id", domainId);
    formData.append("ids", ids);

    return new Promise((resolve, reject) => {
      Drip.deleteArray(formData)
        .then((response) => {
          resolve(response);
          commit("DELETE_DRIP_ARRAY", ids);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
  deleteDripGroupsArray({ commit }, { domainId, ids }) {
    let formData = new FormData();

    formData.append("domain_id", domainId);
    formData.append("ids", ids);

    return new Promise((resolve, reject) => {
      Drip.deleteArray(formData)
        .then((response) => {
          resolve(response);
          commit("DELETE_DRIP_GROUPS_ARRAY", ids);
        })
        .catch((error) => {
          reject(error);
          if (error.response) {
            commit("DETECT_ERROR", error.response);
          }
        })
    })
  },
};

const mutations = {
  GET_DRIP_GROUPS(state, drips) {
    state.dripGroups = drips["data"] != undefined ? drips["data"] : drips;
  },
  ADD_NEW_DRIP_GROUP(state, drips) {
    state.dripGroups.unshift(drips);
  },
  DELETE_DRIP_GROUP(state, id) {
    let obj = state.dripGroups.findIndex((el) => el.group_id == id);
    state.dripGroups.splice(obj, 1);
  },
  GET_DRIPS(state, drips) {
    state.drips = drips["data"] != undefined ? drips["data"] : drips;
  },
  ADD_NEW_DRIP(state, drips) {
    state.drips.push(drips);
  },
  UPDATE_GROUPS_SCHEDULE(state, groups) {
    state.dripGroups = groups;
  },
  UPDATE_ALL_DRIPS(state, drips) {
    state.drips = drips;
  },
  UPDATE_DRIP(state, drip) {
    let obj = state.drips.findIndex((el) => el.id == drip.id);
    state.drips[obj] = drip;
  },
  DELETE_DRIP(state, id) {
    let obj = state.drips.findIndex((el) => el.id == id);
    state.drips.splice(obj, 1);
  },
  DELETE_DRIP_ARRAY(state, ids) {
    let index = null;
    
    for (let [i, id] of ids.entries()) {
      index = state.drips.findIndex((el) => el.id == id);
      state.drips.splice(index, 1);
    }
  },
  DELETE_DRIP_GROUPS_ARRAY(state, ids) {
    let index = null;
    
    for (let [i, id] of ids.entries()) {
      index = state.dripGroups.findIndex((el) => el.id == id);
      state.dripGroups.splice(index, 1);
    }
  },
  DETECT_ERROR(state, error) {
    if (error.status == 401 || error.status == 419) {
      User.logout().then(() => {
        localStorage.removeItem("auth");
        router.push({ name: "Login", path: router.currentRoute.path });
      })
    } else if (error.data.message !== undefined) {
      state.errorWelcomeDrip = error.data.message;
    }

    setTimeout(() => {
      state.errorWelcomeDrip = "";
    }, 1000)
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
